// admin/src/pages/ScimIntegrations/scimPermissions.js

/**
 * Exact permission strings enforced by the SCIM administrative backend.
 * Evaluated without any role-name strings (e.g. role === 'SuperAdmin').
 */
export const SCIM_PERMISSIONS = {
  READ: 'SCIM Integrations-Connections-ConnectionsRead',
  CREATE: 'SCIM Integrations-Connections-ConnectionsCreate',
  UPDATE: 'SCIM Integrations-Connections-ConnectionsUpdate',
  DELETE: 'SCIM Integrations-Connections-ConnectionsDelete',
};

/**
 * Determines whether the authenticated principal is an organization owner.
 * Matches existing pages; tighten when RBAC is finalised.
 *
 * @param {Object} user - Stored user principal
 * @returns {boolean}
 */
export function isOrganizationOwner(user) {
  if (!user || typeof user !== 'object') return false;
  // Matches existing pages; tighten when RBAC is finalised.
  return Boolean(
    user.superadmin ||
    user.role === 'SuperAdmin' ||
    (user.nameOfOrg && !user.roleId)
  );
}

/**
 * Checks if the user is authorized for an administrative SCIM operation.
 * - Genuine organization owners bypass permission checks.
 * - All other users MUST possess the exact permission string in user.permissions.
 *
 * @param {Object} user - Stored user principal
 * @param {string} permission - Exact permission string
 * @returns {boolean}
 */
export function hasScimPermission(user, permission) {
  if (!user || typeof user !== 'object') return false;
  // Matches existing pages; tighten when RBAC is finalised.
  if (isOrganizationOwner(user)) return true;
  if (!permission || typeof permission !== 'string') return false;
  return Array.isArray(user.permissions) && user.permissions.includes(permission);
}
